import { render, staticRenderFns } from "./SocialNetworkInputv2.vue?vue&type=template&id=bbd4c2b6&scoped=true&"
import script from "./SocialNetworkInputv2.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkInputv2.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworkInputv2.vue?vue&type=style&index=0&id=bbd4c2b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd4c2b6",
  null
  
)

export default component.exports